export default "__VITE_ASSET__uPmTNowt__"